import { useState, useEffect, useMemo } from 'react';
const tooltipDelayWhenJustTriggered = 30;
export function useHideTooltipOnTriggerJustClicked(isTriggerClicked) {
  // Used for hiding the tooltip when user just clicks the trigger. Reset to true again when user leaves and comes back to the trigger
  const [shouldShowTooltip, setShouldShowTooltip] = useState(true);
  useEffect(() => {
    // Utilizing a timeout with a dedicated state variable ensures reliable state updates, effectively preventing the tooltip from
    // mistakenly displaying immediately after the trigger button is clicked.
    const timeoutId = setTimeout(() => {
      setShouldShowTooltip(false);
    }, tooltipDelayWhenJustTriggered);
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isTriggerClicked]);
  return useMemo(() => ({
    shouldShowTooltip,
    setShouldShowTooltip
  }), [shouldShowTooltip, setShouldShowTooltip]);
}